module.exports = __webpack_public_path__ + "static/media/pig.c75980ff.svg";